/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SurfacePrizeTier = {
    GRAND: 'GRAND',
    FIRST: 'FIRST',
    SECOND: 'SECOND',
    THIRD: 'THIRD',
    PARTICIPATION: 'PARTICIPATION'
} as const;
export type SurfacePrizeTier = typeof SurfacePrizeTier[keyof typeof SurfacePrizeTier];


export function instanceOfSurfacePrizeTier(value: any): boolean {
    for (const key in SurfacePrizeTier) {
        if (Object.prototype.hasOwnProperty.call(SurfacePrizeTier, key)) {
            if (SurfacePrizeTier[key as keyof typeof SurfacePrizeTier] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfacePrizeTierFromJSON(json: any): SurfacePrizeTier {
    return SurfacePrizeTierFromJSONTyped(json, false);
}

export function SurfacePrizeTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePrizeTier {
    return json as SurfacePrizeTier;
}

export function SurfacePrizeTierToJSON(value?: SurfacePrizeTier | null): any {
    return value as any;
}

export function SurfacePrizeTierToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfacePrizeTier {
    return value as SurfacePrizeTier;
}

